/**
 * Разбор результата занятия.
 *
 * Итог относится к символам своего режима: в предложении режима пунктуации
 * набирается и текст, но точка с запятой — это то, ради чего предложение
 * показано, а буквы в нём тренирует другой режим.
 */

import type {
  KeystrokeEvent,
  MasteryStat,
  MasteryUnit,
  TypingError,
  UnitOutcome,
} from '@type2x/shared-contracts';
import { toMasteryUnitId } from '@type2x/shared-contracts';
import { collectCharacterOutcomes } from '@type2x/typing-engine';
import { applyUnitOutcomes, type LearningConfig } from '@type2x/learning-engine';

import type { SymbolsPlan } from '../contracts/symbols.js';

/** Сопоставляет нажатия символам режима. */
export function collectSymbolOutcomes(
  plan: SymbolsPlan,
  events: readonly KeystrokeEvent[],
  errors: readonly TypingError[],
): UnitOutcome[] {
  const own = new Set(plan.unlockedCharacters);

  return collectCharacterOutcomes(plan.exercise.text, events, errors, { only: own }).map(
    (outcome) => ({
      unitId: toMasteryUnitId(`key:${outcome.character}`),
      attempts: outcome.attempts,
      errors: outcome.errors,
      medianLatencyMs: outcome.medianLatencyMs,
      corrections: outcome.corrections,
    }),
  );
}

/** Обновляет статистику символов по итогам занятия. */
export function applySymbolOutcomes(
  units: readonly MasteryUnit[],
  stats: Readonly<Record<string, MasteryStat>>,
  outcomes: readonly UnitOutcome[],
  config: LearningConfig,
  nowIso: string,
): MasteryStat[] {
  return applyUnitOutcomes(units, stats, outcomes, config, nowIso);
}
